import React, { Component } from 'react'
import PropTypes from "prop-types";
import { ModalWraper, AppSwitch } from '../Components';

class Customer extends  Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
  }
  
  toggle() {
    const { 
      customer, 
      toggleModal, 
      isOpen,
      onSelectCustomer
    } = this.props;

    onSelectCustomer(customer);
    toggleModal(!isOpen);
  }

  handleChangeStatus() {
    const { onChangeStatus, selectedCustomer } = this.props;
    onChangeStatus(selectedCustomer);    
  }

  render() {
    const { 
      customer, 
      customerLoading, 
      customerError, 
      isOpen,
      selectedCustomer
    } = this.props;
  
    const modalDescription = () => {
      return `Are you sure you want to change status for customer ${ selectedCustomer ?  selectedCustomer.name : ''} ?`;
    }
      
    return (
      <React.Fragment>
        <ModalWraper 
          title="Change Customer status"
          description={ modalDescription() }
          isOpen={ isOpen }
          toggleModal={ this.toggle }
          handleAction={ this.handleChangeStatus }
          loading={ customerLoading }
          error={ customerError }
        />
        <tr>
          <td className="text-center">
            <div className="avatar">
              <img src={'/assets/img/avatars/1.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com" />
              <span className="avatar-status badge-success"></span>
            </div>
          </td>
          <td>
            <div>{customer.name}</div>
            <div className="small text-muted">
              <span>New</span> | Registered: Jan 1, 2015
            </div>
          </td>
          <td className="text-center">
            <div>{customer.code}</div>
          </td>
          <td>
            {customer.email}
          </td>
          <td className="text-center">
            {customer.telephone}
          </td>
          <td className="text-center">
            <strong>5</strong>
          </td>
          <td className="text-center">
            <strong>{customer.user_count}</strong>
          </td>
          <td>
            <AppSwitch 
              onChange={ this.toggle }
              className={ 'float-right mb-0' } 
              checked={ customer.status === 1 ? true : false } 
              label 
              color={ 'info' } 
              size={ 'sm' } />
          </td>
        </tr>  
      </React.Fragment>
    )
  }
}

Customer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  isOpen: PropTypes.bool,
  customer: PropTypes.object.isRequired,
  customerLoading: PropTypes.bool,
  customerError: PropTypes.oneOfType([
    PropTypes.string
  ]),
  toggleModal: PropTypes.func,
  onChangeStatus: PropTypes.func,
  selectedCustomer: PropTypes.object,
  onSelectCustomer: PropTypes.func,  
  handleAction: PropTypes.func,
};

Customer.defaultProps = {
  isOpen: false,
  customer: {}
};

export default Customer;



// WEBPACK FOOTER //
// ./src/views/Customer/Customer.js